import { Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { SliderComponent } from 'src/app/components/slider/slider.component';
import { IAccommodationOfferShort } from 'src/app/interfaces/interface';
import { MatDividerModule } from '@angular/material/divider';
import { CommonModule } from '@angular/common';
import { featureIcons } from 'src/app/core/utilits';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ErrorComponentComponent } from 'src/app/components/error-component/error-component.component';

@Component({
  selector: 'app-accomodation-view',
  imports: [
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    SliderComponent,
    MatDividerModule,
    CommonModule,
    MatProgressSpinnerModule,
    ErrorComponentComponent,
  ],
  templateUrl: './accomodation-view.component.html',
  styleUrl: './accomodation-view.component.scss',
})
export class AccomodationViewComponent {
  public localFeatureIcons = featureIcons;

  offer = input<IAccommodationOfferShort | null>();

  reserve = output<number>();
  backToMainPage = output();
  //errors
  isErrorRequest = input<boolean>();
  errorMessage = input<string>();

  hasFeature(features: string[], keyword: string): boolean {
    if (!features || !Array.isArray(features)) return false;
    return features.some(f => f.toLowerCase().includes(keyword.toLowerCase()));
  }

  getParsedPhotos(offer: any): string[] {
    if (!offer) return [];

    try {
      const photos =
        typeof offer.photos === 'string'
          ? JSON.parse(offer.photos)
          : offer.photos;
      return Array.isArray(photos) && photos.length > 0
        ? photos
        : ['../../assets/no-img.png'];
    } catch (e) {
      console.warn('Photo parse error', e);
      return [];
    }
  }
}
